import Dashboard from '../components/employerManagment/Dashboard';

export const EmployerManager = () => {
    return (
        <Dashboard />
    );
};

